// extracted by mini-css-extract-plugin
export default {"card":"Project_card__vP-M1","techlist":"Project_techlist__z-FcS","links":"Project_links__uGhU8"};